<template>
	<div class="label-container">
		<div class="label">
			{{label}}
		</div>
		<div class="allow-blank" v-if="requird">*</div>
	</div>
</template>

<script>
	import {defineComponent} from "vue"
	
	export default defineComponent({
		name: "labelField",
		props: {
			label: {
				type: String,
				default: "label"
			},
			requird:{
				type: Boolean,
				default: false
			}
		}
	})
</script>

<style lang="scss" scoped="scoped">
	@import "~@/assets/styles/_handle.scss";
	
	.label-container{
		display: flex;
		width: fit-content;
		height: fit-content;
		padding: 16px;
		box-sizing: border-box;
		
		.label {
			width: fit-content;
			@include font_family("font_family");
			@include font_color("label-field-color");
			line-height: 18px;
			font-size: 18px;
			display: flex;
			justify-content: center;
			align-items: center;
			align-content: center;
			white-space: nowrap;
			box-sizing: border-box;
		}
		
		.allow-blank{
			width: fit-content;
			display: flex;
			@include font_color("label-field-allowBlank-color");
			margin-left: 8px;
			line-height: 18px;
			font-size: 18px;
		}
	}
</style>
